import { useMfaServiceMfaAuditLogsList } from '@organization/api/queries'
import { MFAAuditLog } from '@organization/api/requests'
import { TitleSection } from '@shared/components'
import { usePaginationConfig, useQueryUpdate, useSorting } from '@shared/hooks'
import { Flex } from 'antd'
import { useTranslation } from 'react-i18next'

import { LogMFAFilters, LogMFAHeader, LogMFATable } from '../components'

export const LogsMFAPage = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()

  const { triggerSort, getSortedTableColumns } = useSorting<MFAAuditLog>()

  const { data, isLoading } = useMfaServiceMfaAuditLogsList(params)

  return (
    <>
      <TitleSection
        title={t('menu.logs_mfa')}
        count={data?.count}
        isLoading={isLoading}
      >
        <LogMFAHeader />
      </TitleSection>

      <Flex vertical gap={16}>
        <LogMFAFilters />

        <LogMFATable
          data={data?.results}
          loading={isLoading}
          triggerSort={triggerSort}
          getSortedTableColumns={getSortedTableColumns}
          pagination={{
            ...usePaginationConfig(data),
            onChange: (page: number, pageSize: number) =>
              updateQuery({
                ...params,
                page: page.toString(),
                pageSize: pageSize.toString()
              })
          }}
        />
      </Flex>
    </>
  )
}
